import { useAuth } from '../context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { Link, Navigate } from 'react-router-dom';
import { api } from '../lib/api';
import NeighbourhoodCard from '../components/common/NeighbourhoodCard';
import WatchlistDashboard from '../components/common/WatchlistDashboard';

export default function Dashboard() {
    const { user, loading } = useAuth();
    const { data: favs } = useQuery({
        queryKey: ['favorites'],
        queryFn: async () => (await api.get('/user/favorites')).data,
        enabled: !!user,
    });

    if (loading) return <div className="p-16 text-neutral-500">Loading…</div>;
    if (!user) return <Navigate to="/login" replace />;

    return (
        <div>
            <section className="border-b border-neutral-200">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-14 pb-8">
                    <div className="overline">Your account</div>
                    <h1 className="font-editorial text-[40px] lg:text-[52px] tracking-editorial mt-4">
                        Welcome back, {user.name?.split(' ')[0]}.
                    </h1>
                    <div className="mt-4 text-[14px] text-neutral-500 font-mono-data">{user.email}</div>
                </div>
            </section>

            <section>
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10">
                    <div className="overline mb-4">Saved neighbourhoods</div>
                    {favs?.items?.length ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {favs.items.map((n) => <NeighbourhoodCard key={n.slug} n={n} />)}
                        </div>
                    ) : (
                        <div className="border border-neutral-200 p-10 text-neutral-500">
                            You haven&apos;t saved any neighbourhoods yet. <Link to="/neighbourhoods" className="link-editorial ml-1 text-black">Start exploring →</Link>
                        </div>
                    )}
                </div>
            </section>

            <WatchlistDashboard userEmail={user.email} />

            {user.is_admin && (
                <section className="border-t border-neutral-200">
                    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10">
                        <div className="overline">Admin</div>
                        <div className="mt-3 flex flex-wrap gap-4">
                            <Link to="/admin/leads" className="link-editorial text-[15px]">Manage leads →</Link>
                            <Link to="/admin/schools" className="link-editorial text-[15px]">Refresh school data →</Link>
                        </div>
                    </div>
                </section>
            )}
        </div>
    );
}
